import { createFileRoute } from "@tanstack/react-router";
import { HighlightColor, HighlightDataTexture } from "gfx/HighlightDataTexture";
import type { THREEViewerLiteOptions } from "gfx/THREEViewerLite";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import {
  addTextTestTHREEGeometry,
  TEXT_TEST_CAMERA_SETTINGS,
  TEXT_TEST_HIGHLIGHTED_ID,
  TEXT_TEST_KEYS,
} from "test/util/textTestUtil";
import withAuthentication from "../../components/withAuthentication";

function TextTestPage() {
  const highlightDataTexture = new HighlightDataTexture();
  highlightDataTexture.selectId(TEXT_TEST_HIGHLIGHTED_ID, HighlightColor.BLUE);

  const options: Partial<THREEViewerLiteOptions> = {
    cameraSettings: TEXT_TEST_CAMERA_SETTINGS,
    useMSAA: false,
    highlightDataTexture,
  };

  return (
    <HeadlessRenderTestPage
      testName="Text render"
      options={options}
      testKeys={TEXT_TEST_KEYS}
      addGeometry={addTextTestTHREEGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/text-test")({
  component: withAuthentication(TextTestPage, { superAdmin: true }),
});
